// extracted by mini-css-extract-plugin
export default {"Logo":"Logo-styles__Logo__y6ugD","Logo__image":"Logo-styles__Logo__image__EKsn1"};